import React, { useMemo } from 'react';
import DataGrid from '../../../../../common/DataGrid/DataGrid';
import { useDataGridTextFilter } from '../../../../../common/DataGrid/filters/useDataGridTextFilter';
import {
  dataGridTextSorter,
} from '../../../../../common/DataGrid/sorters/DataGridSorters';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const HelpTable = ({ helps = [], onEdit, onDelete, onPreview }) => {
  const { t } = useTranslation();

  const titleTextFilterProps = useDataGridTextFilter('title');
  const urlTextFilterProps = useDataGridTextFilter('url');
  const slugTextFilterProps = useDataGridTextFilter('slug');

  const columns = useMemo(
    () => [

      {
        title: 'URL',
        dataIndex: 'url',
        ellipsis: true,
        sorter: dataGridTextSorter('url'),
        ...urlTextFilterProps,
      },
      {
        title: t('URL adresa'),
        dataIndex: 'slug',
        ellipsis: true,
        sorter: dataGridTextSorter('slug'),
        ...slugTextFilterProps,
        render: (slug) => slug === 1 ? t('Je nastavený') : t('Nie je nastavený'),
      },
      {
        title: t('Nadpis'),
        dataIndex: 'title',
        ellipsis: true,
        sorter: dataGridTextSorter('title'),
        defaultSortOrder: 'ascend',
        ...titleTextFilterProps,
      },
      {
        title: t('Obsah'),
        dataIndex: 'content',
        ellipsis: true,
        sorter: dataGridTextSorter('content'),
      },
      {
        title: t('Role'),
        dataIndex: 'roles',
        render: (roles) =>
          Array.isArray(roles) && roles.length > 0
            ? roles.map(role => role.name).join(', ')
            : t('Žiadne role'),
      }
    ],
    [t, titleTextFilterProps, urlTextFilterProps, slugTextFilterProps]
  );

  return (
    <DataGrid
      rowKey={(record) => record.id}
      columns={columns}
      dataSource={helps || []}
      permissionsBasic={'help'}
      onEditClick={record => onEdit(record.id)}
      onDelete={onDelete}
      onPreviewClick={onPreview}
      onRowClick={onPreview}
      rowClickOpensPreview
    />
  );
};

HelpTable.propTypes = {
  helps: PropTypes.array,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onPreview: PropTypes.func
};

export default HelpTable;
